import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '@uoa/auth';
import { PromptListComponent } from './prompt-list/prompt-list.component';
import { environment } from '../../../environments/environment';
import { PromptEditComponent } from './prompt-edit/prompt-edit.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { HelpComponent } from './home/help.component';
import { SelfServiceComponent } from './self-service.component';
import { SELF_SERVICE_ROUTE_PATHS } from 'src/app/core/route-paths';

const routes: Routes = [
  {
    path: '',
    component: SelfServiceComponent,
    data: {
      audit: environment.wallboards.prompt.audit,
      prompts: environment.wallboards.prompt.prompts,
      polly: environment.wallboards.prompt.polly,
    },
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: PromptListComponent,
        data: {
          audit: environment.wallboards.prompt.audit,
          prompts: environment.wallboards.prompt.prompts,
          polly: environment.wallboards.prompt.polly,
        },
      },
      {
        path: SELF_SERVICE_ROUTE_PATHS.edit,
        canActivate: [AuthGuard],
        component: PromptEditComponent,
        data: {
          audit: environment.wallboards.prompt.audit,
          prompts: environment.wallboards.prompt.prompts,
          polly: environment.wallboards.prompt.polly,
        },
      },
      {
        path: SELF_SERVICE_ROUTE_PATHS.auditLog,
        canActivate: [AuthGuard],
        component: AuditLogComponent,
        data: {
          audit: environment.wallboards.prompt.audit,
          prompts: environment.wallboards.prompt.prompts,
          polly: environment.wallboards.prompt.polly,
        },
      },
      {
        path: SELF_SERVICE_ROUTE_PATHS.help,
        component: HelpComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelfServiceRoutingModule {}
